import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Spin } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../Modules/Presentation/hooks';
import { selectUser } from '../../Modules/User/Presentation/selectors';
import { logout } from '../../Modules/User/Presentation/reducers';
import dayjs from 'dayjs';
import { levelKor } from '../../Utils/permission';

const { Title } = Typography;

const MyPage: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);

    /* 로딩 대비 */
    if (!user) {
        return <Spin style={{ display: 'block', margin: '160px auto' }} />;
    }

    /* 로그아웃 → /login */
    const handleLogout = () => {
        dispatch(logout());
        // 로그아웃 시 앱 상태를 완전히 초기화하기 위해 리로드(=새로고침)로 이동
        window.location.replace('/login');
    };

    return (
        <Card style={{ maxWidth: 620, margin: '48px auto', borderRadius: 12 }}>
            <Title level={3} style={{ textAlign: 'center', marginBottom: 32 }}>
                내 프로필
            </Title>

            <Descriptions column={1} bordered size="middle">
                <Descriptions.Item label="아이디">{user.username}</Descriptions.Item>
                <Descriptions.Item label="이름">{user.name}</Descriptions.Item>
                <Descriptions.Item label="등급">
                    {levelKor[user.grade] ?? user.grade}
                </Descriptions.Item>
                <Descriptions.Item label="가입일">
                    {user.createdAt && dayjs(user.createdAt).isValid()
                        ? dayjs(user.createdAt).format('YYYY-MM-DD')
                        : '-'}
                </Descriptions.Item>
                {user.memo && (
                    <Descriptions.Item label="메모">{user.memo}</Descriptions.Item>
                )}
            </Descriptions>

            <Space style={{ marginTop: 32, width: '100%', justifyContent: 'center' }}>
                <Button
                    danger
                    icon={<LogoutOutlined />}
                    onClick={handleLogout}
                >
                    로그아웃
                </Button>
            </Space>
        </Card>
    );
};

export default MyPage;
